import { ContentDialog } from '@spark-web/modal-dialog';
import { TextLinkButton } from '@spark-web/text-link';
import { useDisclosure } from '@spark-web/utils';
import DirectDebitAgreement from './DirectDebitAgreement';

type Props = {
  setValue: (value: string) => void;
  watch: (name: string) => string;
};

function DirectDebitAgreementButton({ setValue, watch }: Props) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault(); //prevent click event from bubbling up to the checkbox
    onToggle();
  };
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <>
      <TextLinkButton onClick={handleClick}>Direct Debit Agreement</TextLinkButton>
      <ContentDialog isOpen={isOpen} title="Direct Debit Request Service Agreement" onToggle={onToggle} size="medium">
        <DirectDebitAgreement onClose={onClose} setValue={setValue} watch={watch} />
      </ContentDialog>
    </>
  );
}

export default DirectDebitAgreementButton;
